module.exports = __webpack_public_path__ + "static/img/smbg1.0b7968d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/smbg1.png
// module id = h0tm
// module chunks = 1